import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import config from '../config/config';

const Terms = () => {
  const [title, setTitle] = useState('Privacy');
  const [content, setContent] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [metaKeywords, setMetaKeywords] = useState('');
  const location = useLocation();

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/get-terms-content`);
        if (response.data.success) {
          const pageContent = response.data.data['page-content']; 
          setTitle(pageContent.title);
          setContent(pageContent.content);

          // Set SEO metadata
          const seo = response.data.data['page-seo'];
          setMetaTitle(seo.meta_title);
          setMetaDescription(seo.meta_description);
          setMetaKeywords(seo.meta_keyword);
        }
      } catch (error) {
        console.error('Failed to fetch content:', error);
      }
    };

    fetchContent();
  }, []);

  useLayoutEffect(() => {
    if (location.hash) {
      const elementId = location.hash.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  useEffect(() => {
    // Update document head with SEO metadata
    document.title = metaTitle || 'Default Title';
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    const metaKeywordsTag = document.querySelector('meta[name="keywords"]');
    
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute('content', metaDescription || '');
    } else {
      const newMetaDescriptionTag = document.createElement('meta');
      newMetaDescriptionTag.name = 'description';
      newMetaDescriptionTag.content = metaDescription || '';
      document.head.appendChild(newMetaDescriptionTag);
    }

    if (metaKeywordsTag) {
      metaKeywordsTag.setAttribute('content', metaKeywords || '');
    } else {
      const newMetaKeywordsTag = document.createElement('meta');
      newMetaKeywordsTag.name = 'keywords';
      newMetaKeywordsTag.content = metaKeywords || '';
      document.head.appendChild(newMetaKeywordsTag);
    }
  }, [metaTitle, metaDescription, metaKeywords]);

  return (
    <div>
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/">
                <img src={staticlogo} alt="" /> PatreonPass
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section className="inner_static">
        <div className="container">
          <div className="row">
            <div className="page_title_header">{title}</div>
            <div className="page_content_static">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;
